import type { ButtonHTMLAttributes, Ref } from 'react';

import Loading from '@cartwhl/ui/atoms/Loading';
import BellIcon from '@cartwhl/ui/icons/BellIcon';
import Button from '@cartwhl/ui/input/Button';
import { HEADER_ICON_BUTTON_CLASSNAME } from '@cartwhl/ui/layout/StudioShellHeader';

export default function NotificationButton({
  showIndicator = false,
  processing = false,
  appletHeader = false,
  ref,
  className,
  type = 'button',
  ...props
}: {
  showIndicator?: boolean;
  processing?: boolean;
  appletHeader?: boolean;
  ref?: Ref<HTMLButtonElement>;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'>) {
  const indicator = (
    <>
      {processing && (
        <span
          className={`bg-primary pointer-events-none absolute ${showIndicator ? 'left-0.5 -translate-x-1/2' : 'right-0.5 translate-x-1/2'} top-0.5 -translate-y-1/2 rounded-full p-0.5`}
          role="status"
          aria-label="Motion capture in progress"
        >
          <Loading className="text-secondary size-3" />
        </span>
      )}
      {showIndicator && (
        <span
          className="bg-green pointer-events-none absolute right-0.5 top-0.5 size-3 -translate-y-1/2 translate-x-1/2 rounded-full"
          aria-label="Unseen notifications"
        />
      )}
    </>
  );
  if (appletHeader) {
    return (
      <Button
        ref={ref}
        type={type}
        variant="secondary"
        size="sm"
        icon={
          <span className="block">
            <BellIcon className="size-5" />
            {indicator}
          </span>
        }
        iconSize={20}
        className={`relative overflow-visible p-1 ${className ?? ''}`}
        aria-label="Notifications"
        {...props}
      />
    );
  }

  return (
    <button
      ref={ref}
      type={type}
      className={`${HEADER_ICON_BUTTON_CLASSNAME} relative overflow-visible ${className ?? ''}`}
      aria-label="Notifications"
      {...props}
    >
      <BellIcon className="text-primary h-7 w-7" />
      {indicator}
    </button>
  );
}
